// extracted by mini-css-extract-plugin
export default {"pieChart":"DBWYsg"};